// Les blocs de l'espace (tenant) de l'élève. Le serveur pose sur l'utilisateur
// courant `disabled_blocks` : la liste des blocs éteints dans son espace (vide
// pour le B2C France). Le serveur refuse déjà ce qu'un bloc éteint couvre ; l'app
// cache seulement les entrées qui y mènent.
// Checkpoints et correction n'y sont pas : pendant un cours ils suivent l'espace
// du cours, que seul le serveur connaît.
export const TENANT_BLOCKS = {
    GAMIFICATION: "gamification",
    EXTRA_HOURS: "extra_hours",
    SUBSCRIPTION: "subscription",
    PARENTS: "parents",
    PAUSE_SUMMER: "pause_summer",
    TRIAL: "trial",
}

// « Ce bloc est-il allumé pour cet utilisateur ? » — la seule lecture de la
// règle côté app. Une clé absente (ancien backend, store persisté) veut dire
// que rien n'est éteint.
export const isBlockOn = (user, slug) =>
    !(user?.disabled_blocks ?? []).includes(slug)
